// extracted by mini-css-extract-plugin
export var closeButton = "_gf-2";
export var closeButtonIcon = "_gf-3";
export var lightboxContent = "_gf-1";
export var lightboxOverlay = "_gf-0";